import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
/**
 * 颜色处理工具函数
 */

/**
 * 颜色转RGB (支持十六进制和rgba格式)
 * @param {string} color - 颜色值 (#FF0000, #F00, rgb(255,0,0), rgba(255,0,0,1))
 * @returns {Object|null} - {r, g, b} 或 null
 */
export function colorToRgb(color) {
  if (!color) return null;

  // 处理rgba格式
  if (color.startsWith('rgb')) {
    var match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/);
    if (match) {
      return {
        r: parseInt(match[1]),
        g: parseInt(match[2]),
        b: parseInt(match[3])
      };
    }
    return null;
  }

  // 处理十六进制格式
  if (color.startsWith('#')) {
    var hex = color.replace('#', '');

    // 处理3位和6位十六进制
    if (hex.length === 3) {
      hex = hex.split('').map(function (char) {
        return char + char;
      }).join('');
    }
    if (hex.length !== 6) return null;
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return {
      r: r,
      g: g,
      b: b
    };
  }
  return null;
}

/**
 * 十六进制颜色转RGB (保持向后兼容)
 * @param {string} hex - 十六进制颜色值 (#FF0000 或 #F00)
 * @returns {Object|null} - {r, g, b} 或 null
 */
export function hexToRgb(hex) {
  return colorToRgb(hex);
}

/**
 * RGB转十六进制
 * @param {number} r - 红色值 (0-255)
 * @param {number} g - 绿色值 (0-255)
 * @param {number} b - 蓝色值 (0-255)
 * @returns {string} - 十六进制颜色值
 */
export function rgbToHex(r, g, b) {
  return '#' + [r, g, b].map(function (x) {
    var hex = x.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }).join('');
}

/**
 * 调整颜色亮度
 * @param {string} color - 颜色值 (支持十六进制和rgba)
 * @param {number} percent - 亮度调整百分比 (-100 到 100)
 * @returns {string} - 调整后的十六进制颜色值
 */
export function adjustBrightness(color, percent) {
  var rgb = colorToRgb(color);
  if (!rgb) return color;
  var r = rgb.r,
    g = rgb.g,
    b = rgb.b;
  var factor = percent / 100;
  var newR = Math.max(0, Math.min(255, Math.round(r + (255 - r) * factor)));
  var newG = Math.max(0, Math.min(255, Math.round(g + (255 - g) * factor)));
  var newB = Math.max(0, Math.min(255, Math.round(b + (255 - b) * factor)));
  return rgbToHex(newR, newG, newB);
}

/**
 * 生成颜色的透明度变体
 * @param {string} color - 颜色值 (支持十六进制和rgba)
 * @param {number} alpha - 透明度 (0-1)
 * @returns {string} - rgba颜色值
 */
export function hexToRgba(color) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var rgb = colorToRgb(color);
  if (!rgb) return "rgba(0, 0, 0, ".concat(alpha, ")");
  var r = rgb.r,
    g = rgb.g,
    b = rgb.b;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
}

/**
 * 生成分类标签样式（主要用于课程分类）
 * @param {string} color - 主颜色
 * @param {Object} options - 配置选项
 * @returns {Object} - 样式对象
 */
export function getCategoryTagStyle(color) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$backgroundAl = options.backgroundAlpha,
    backgroundAlpha = _options$backgroundAl === void 0 ? 0.1 : _options$backgroundAl,
    _options$borderAlpha = options.borderAlpha,
    borderAlpha = _options$borderAlpha === void 0 ? 0.4 : _options$borderAlpha,
    _options$textColor = options.textColor,
    textColor = _options$textColor === void 0 ? color : _options$textColor;
  if (!color) {
    return {
      backgroundColor: '#f5f5f5',
      borderColor: '#d9d9d9',
      color: '#666666'
    };
  }
  var rgb = colorToRgb(color);
  if (!rgb) {
    return {
      backgroundColor: '#f5f5f5',
      borderColor: '#d9d9d9',
      color: color
    };
  }
  var r = rgb.r,
    g = rgb.g,
    b = rgb.b;
  return {
    backgroundColor: "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(backgroundAlpha, ")"),
    borderColor: "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(borderAlpha, ")"),
    color: textColor
  };
}

/**
 * 生成渐变色样式
 * @param {string} startColor - 起始颜色
 * @param {string} endColor - 结束颜色
 * @param {string} direction - 渐变方向 (to right, to bottom, etc.)
 * @returns {string} - CSS渐变样式
 */
export function getGradientStyle(startColor, endColor) {
  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'to right';
  return "linear-gradient(".concat(direction, ", ").concat(startColor, ", ").concat(endColor, ")");
}

/**
 * 判断颜色是否为深色
 * @param {string} color - 颜色值 (支持十六进制和rgba)
 * @returns {boolean} - 是否为深色
 */
export function isDarkColor(color) {
  var rgb = colorToRgb(color);
  if (!rgb) return false;
  var r = rgb.r,
    g = rgb.g,
    b = rgb.b;
  // 使用相对亮度公式
  var brightness = (r * 299 + g * 587 + b * 114) / 1000;
  return brightness < 128;
}

/**
 * 获取对比色（黑色或白色）
 * @param {string} color - 颜色值 (支持十六进制和rgba)
 * @returns {string} - 对比色
 */
export function getContrastColor(color) {
  return isDarkColor(color) ? '#ffffff' : '#000000';
}

/**
 * 生成颜色主题样式
 * @param {string} primaryColor - 主色
 * @returns {Object} - 主题样式对象
 */
export function generateColorTheme(primaryColor) {
  return {
    primary: primaryColor,
    light: adjustBrightness(primaryColor, 30),
    lighter: adjustBrightness(primaryColor, 60),
    dark: adjustBrightness(primaryColor, -30),
    darker: adjustBrightness(primaryColor, -60),
    background: hexToRgba(primaryColor, 0.1),
    border: hexToRgba(primaryColor, 0.3),
    text: getContrastColor(primaryColor)
  };
}

/**
 * 预设的颜色主题
 */
export var COLOR_THEMES = {
  blue: '#409EFF',
  green: '#67C23A',
  orange: '#E6A23C',
  red: '#F56C6C',
  purple: '#909399',
  pink: '#FF6B6B',
  cyan: '#4ECDC4',
  indigo: '#45B7D1',
  lime: '#96CEB4',
  yellow: '#FFEAA7'
};

/**
 * 获取随机颜色
 * @returns {string} - 随机十六进制颜色
 */
export function getRandomColor() {
  var colors = Object.values(COLOR_THEMES);
  return colors[Math.floor(Math.random() * colors.length)];
}

/**
 * 测试颜色转换功能
 * @param {string} color - 要测试的颜色
 * @returns {Object} - 测试结果
 */
export function testColorConversion(color) {
  var rgb = colorToRgb(color);
  if (rgb) {
    var style = getCategoryTagStyle(color);
    return {
      success: true,
      rgb: rgb,
      style: style
    };
  } else {
    return {
      success: false
    };
  }
}